<template>
  <section class="bm-records">
    <div class="bm-records__tags">
      <button :class="{ active: type === '' }" @click="type = ''; load(1)">全部</button>
      <button :class="{ active: type === 'status' }" @click="type = 'status'; load(1)">上下架</button>
      <button :class="{ active: type === 'timer_status' }" @click="type = 'timer_status'; load(1)">定时上下架</button>
      <select v-model="status" aria-label="批次状态" @change="load(1)"><option value="">全部状态</option><option v-for="(name, value) in batchNames" :key="value" :value="Number(value)">{{ name }}</option></select>
      <button :disabled="loading" @click="load(page)">{{ loading ? '加载中…' : '刷新' }}</button>
    </div>
    <p v-if="error" class="danger" role="alert">{{ error }}</p>
    <div class="bm-records__table-wrap"><table>
      <thead><tr><th>修改内容</th><th>处理进度</th><th>状态</th><th>排位位置</th><th>受理成功</th><th>失败数</th><th>跳过数</th><th>取消 / 待确认</th><th>商品 / 动作数</th><th>时间</th><th>操作</th></tr></thead>
      <tbody><tr v-for="row in rows" :key="row.id">
        <td><strong>{{ row.type === 'timer_status' ? '定时上下架' : '上下架' }}</strong><small>{{ row.batch_no }}</small></td>
        <td><div class="bm-records__progress"><i :style="{ width: percentage(row.progress) + '%' }"></i></div><b>{{ percentage(row.progress) }}%</b></td>
        <td><span class="bm-records__status" :class="batchOutcome(row).style">{{ batchOutcome(row).label }}</span></td>
        <td><template v-if="row.queue_position != null && [1,2].includes(row.status)">第 {{ row.queue_position }} 位<small>前方 {{ row.queue_ahead_count }} 个待处理任务</small></template><template v-else>—</template></td>
        <td class="success">{{ row.success_count }}</td><td class="danger">{{ row.fail_count }}</td><td>{{ row.skip_count }}</td><td>{{ row.cancelled_count }} / {{ row.pending_confirmation_count }}</td><td>{{ row.product_total }} / {{ row.action_total }}</td><td><small>创建 {{ row.created_at || '—' }}<br />结束 {{ row.finished_at || '—' }}</small></td>
        <td class="bm-records__actions"><button class="blue" @click="openDetails(row)">查看详情</button><button v-if="[1,2,3].includes(row.status)" class="danger" :disabled="cancelling !== null" @click="cancel(row)">{{ cancelling === row.id ? '取消中…' : '取消' }}</button></td>
      </tr><tr v-if="!rows.length"><td colspan="11" class="empty">{{ loading ? '加载中…' : '暂无记录数据' }}</td></tr></tbody>
    </table>
    <footer><span>共 {{ total }} 条 · 共 {{ Math.max(1, Math.ceil(total / 20)) }} 页</span><span><button :disabled="page <= 1 || loading" @click="load(page - 1)">上一页</button> <b>{{ page }} / {{ Math.max(1, Math.ceil(total / 20)) }}</b> <button :disabled="page * 20 >= total || loading" @click="load(page + 1)">下一页</button> <span>20条/页</span></span></footer>
    </div>
    <p class="wx-note">商品处理统计按动作计算；受理成功不代表已在售，实际平台状态请查看明细。排位按等待批次创建顺序统计，定时动作仍按计划时间执行。首期不提供执行后恢复。</p>
    <div v-if="detailsOpen" class="bm-records__mask" @keydown.esc="detailsOpen = false; closeDetails()">
      <section class="bm-records__modal" role="dialog" aria-modal="true" aria-label="微信批量修改明细">
        <header><strong>微信批量修改明细</strong><button aria-label="关闭明细" @click="detailsOpen = false; closeDetails()">×</button></header>
        <div class="bm-records__modal-body">
          <nav><select v-model="detailStatus" aria-label="动作状态" @change="loadDetails(1)"><option value="">全部动作状态</option><option v-for="(name, value) in detailNames" :key="value" :value="Number(value)">{{ name }}</option></select><button :disabled="detailsLoading" @click="loadDetails(detailPage)">刷新明细</button></nav>
          <p v-if="detailError" class="wx-note danger" role="alert">{{ detailError }}</p>
          <table><thead><tr><th>商品 / 店铺</th><th>动作</th><th>计划 / 实际调用时间</th><th>处理 / 平台状态</th><th>原因</th></tr></thead>
          <tbody><tr v-for="row in details" :key="row.id || row.platform_product_id + row.action">
            <td>{{ row.product_title }}<small>{{ row.platform_product_id }}</small><small>{{ row.shop_name || row.shop_id }}</small></td><td>{{ row.action === 'online' ? '上架' : '下架' }}</td><td><small>计划：{{ row.scheduled_at || '立即' }}</small><small>实际：{{ row.execution_started_at || '—' }}</small></td>
            <td>{{ detailNames[row.status] || '未知' }}<small v-if="[1,2].includes(row.status) && row.needs_detail != null">{{ row.needs_detail === 1 && !row.detail_checked_at ? '实时详情核验' : '上下架处理' }}</small><small>{{ platformNames[row.platform_result] || '未知' }}</small><small v-if="row.raw_edit_status != null">草稿：{{ editNames[row.raw_edit_status] || '未知' }}</small><small v-if="row.sync_pending">本地待同步</small></td>
            <td>{{ row.error_msg || row.reason_code || '—' }}<small v-if="row.errcode != null">微信错误码：{{ row.errcode }}</small></td>
          </tr><tr v-if="!details.length"><td colspan="5" class="empty">{{ detailsLoading ? '加载中…' : '暂无明细数据' }}</td></tr></tbody></table>
          <p class="wx-note">时间为北京时间。取消仅停止尚未提交的动作；在途请求无法撤回，结果未知时只查询确认。</p>
        </div>
        <footer><span>共 {{ detailTotal }} 条</span><button :disabled="detailPage <= 1 || detailsLoading" @click="loadDetails(detailPage - 1)">上一页</button><b>{{ detailPage }} / {{ Math.max(1, Math.ceil(detailTotal / 20)) }}</b><button :disabled="detailPage * 20 >= detailTotal || detailsLoading" @click="loadDetails(detailPage + 1)">下一页</button><button @click="detailsOpen = false; closeDetails()">关闭</button></footer>
      </section>
    </div>
  </section>
</template>

<script>
import { getWechatBatchList, getWechatBatchDetails, cancelWechatBatch } from '@/api/main/wechatBatchEdit'

export default {
  name: 'WechatBatchModifyRecords',
  data: () => ({
    rows: [], total: 0, page: 1, type: '', status: '', loading: false, error: '', cancelling: null,
    detailsOpen: false, detailBatch: null, details: [], detailStatus: '', detailPage: 1, detailTotal: 0, detailsLoading: false, detailError: '',
    timer: null, listRequest: 0, detailRequest: 0, destroyed: false,
    batchNames: { 1: '待处理', 2: '待调度', 3: '处理中', 4: '处理完成', 5: '批次异常', 7: '已取消' },
    detailNames: { 1: '待处理', 2: '处理中', 3: '待确认', 4: '受理成功', 5: '失败', 6: '已跳过', 7: '已取消' },
    platformNames: { 0: '实际状态待核验', 1: '在售', 2: '已下架', 3: '审核中' },
    editNames: { 0: '初始', 1: '编辑中', 2: '审核中', 3: '审核失败', 4: '审核成功', 7: '上传中', 8: '上传失败', 70: '提审中', 72: '提审额度不足', 73: '提审限频' }
  }),
  created() { this.load(1) },
  beforeDestroy() { this.destroyed = true; clearTimeout(this.timer); this.listRequest++; this.detailRequest++ },
  methods: {
    batchOutcome(row) {
      if (row.status === 4) {
        if (row.action_total > 0 && row.fail_count === row.action_total) return { label: '全部失败', style: 'failed' }
        if (row.fail_count > 0) return { label: '部分失败', style: 'processing' }
        if (row.action_total > 0 && row.skip_count === row.action_total) return { label: '全部跳过', style: 'cancelled' }
        return { label: '处理完成', style: 'completed' }
      }
      return { label: this.batchNames[row.status] || '未知', style: row.status === 5 ? 'failed' : row.status === 7 ? 'cancelled' : 'processing' }
    },
    percentage(value) { return Math.max(0, Math.min(100, Number(value) || 0)) },
    async load(page = 1) {
      const version = ++this.listRequest; clearTimeout(this.timer); this.loading = true; this.error = ''
      try {
        const data = await getWechatBatchList({ page, page_size: 20, ...(this.type ? { type: this.type } : {}), ...(this.status ? { status: this.status } : {}) })
        if (this.destroyed || version !== this.listRequest) return
        this.rows = data.list || []; this.total = data.total || 0; this.page = page
        if (this.rows.some((row) => [1,2,3].includes(row.status) || row.pending_confirmation_count > 0)) this.timer = setTimeout(() => this.load(this.page), 8000)
      } catch (e) { if (!this.destroyed && version === this.listRequest) this.error = e.message || '记录加载失败' }
      finally { if (version === this.listRequest) this.loading = false }
    },
    openDetails(row) { this.detailRequest++; this.detailBatch = row.id; this.details = []; this.detailStatus = ''; this.detailsOpen = true; this.loadDetails(1) },
    closeDetails() { this.detailRequest++; this.detailBatch = null; this.details = []; this.detailsLoading = false },
    async loadDetails(page = 1) {
      if (!this.detailBatch) return
      const version = ++this.detailRequest; this.detailsLoading = true; this.detailError = ''
      try {
        const data = await getWechatBatchDetails(this.detailBatch, { page, page_size: 20, ...(this.detailStatus ? { status: this.detailStatus } : {}) })
        if (this.destroyed || version !== this.detailRequest || !this.detailsOpen) return
        this.details = data.list || []; this.detailTotal = data.total || 0; this.detailPage = page
      } catch (e) { if (version === this.detailRequest && !this.destroyed) this.detailError = e.message || '明细加载失败' }
      finally { if (version === this.detailRequest) this.detailsLoading = false }
    },
    async cancel(row) {
      if (this.cancelling !== null) return
      this.cancelling = row.id
      try {
        await this.$confirm('取消尚未提交的动作；已提交请求仍继续核查结果，无法撤回。', '取消批次', { type: 'warning' })
        const data = await cancelWechatBatch(row.id)
        if (this.destroyed) return
        this.$message.success('已取消；待确认动作 ' + data.pending_confirmation_count + ' 个')
        await this.load(this.page)
        if (this.detailsOpen && this.detailBatch === row.id) this.loadDetails(this.detailPage)
      } catch (e) { if (!this.destroyed && e !== 'cancel' && e !== 'close') this.error = e.message || '取消失败' }
      finally { this.cancelling = null }
    }
  }
}
</script>
<style scoped>
.bm-records {
  padding: 14px 20px;
  font-family: 'Noto Sans SC', sans-serif;
}
.bm-records__tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 14px;
}
.bm-records__queue {
  margin-bottom: 12px;
  padding: 10px 12px;
  background: #f5f7fa;
  color: #606266;
  font-size: 12px;
}
.bm-records__queue span {
  margin-left: 16px;
}
.bm-records__queue small {
  display: block;
  margin-top: 6px;
  color: #909399;
}
.bm-records__actions {
  min-width: 150px;
}
.bm-records__actions button {
  margin: 2px 4px 2px 0;
  white-space: nowrap;
}
.bm-records__status.cancelled {
  background: #f0f0f0;
  color: #909399;
}
.bm-records button,
.bm-records select {
  height: 26px;
  padding: 0 10px;
  border: 1px solid #e0e0ec;
  border-radius: 4px;
  background: #fff;
  color: #666;
  cursor: pointer;
  font-size: 11px;
}
.bm-records button.active {
  border-color: #1677ff;
  background: #1677ff;
  color: #fff;
}
.bm-records button:disabled {
  color: #bbb;
  cursor: not-allowed;
}
.bm-records__table-wrap,
.bm-records__modal {
  overflow: hidden;
  border: 1px solid #e0e0ec;
  border-radius: 8px;
  background: #fff;
}
.bm-records__table-wrap {
  overflow-x: auto;
}
.bm-records__modal {
  overflow-x: auto;
}
.bm-records table {
  width: 100%;
  min-width: 1060px;
  border-collapse: collapse;
}
.bm-records th {
  padding: 8px 12px;
  background: #f5f0e8;
  color: #666;
  font-size: 11px;
  text-align: left;
}
.bm-records td {
  padding: 12px;
  border-bottom: 1px solid #f5f5f5;
  font-size: 12px;
}
.bm-records td small {
  display: block;
  margin-top: 3px;
  color: #999;
  font-size: 11px;
  line-height: 1.5;
}
.bm-records__progress {
  display: inline-block;
  width: 90px;
  height: 6px;
  overflow: hidden;
  border-radius: 3px;
  background: #f0f0f0;
}
.bm-records__progress i {
  display: block;
  height: 100%;
  background: #e05858;
}
.bm-records td > b {
  margin-left: 6px;
  color: #c8443c;
  font-size: 10px;
}
.bm-records__status {
  padding: 2px 8px;
  border-radius: 3px;
  font-size: 11px;
}
.bm-records__status.completed {
  background: #f6ffed;
  color: #52c41a;
}
.bm-records__status.failed {
  background: #fff5f5;
  color: #c8443c;
}
.bm-records__status.processing {
  background: #fff7e6;
}
.bm-records__status.processing {
  color: #fa8c16;
}
.success {
  color: #52c41a;
}
.danger {
  color: #c8443c;
}
.blue {
  border-color: #91caff !important;
  background: #e6f4ff !important;
  color: #1677ff !important;
}
.bm-records footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 10px 14px;
  background: #f5f0e8;
  color: #999;
  font-size: 11px;
}
.bm-records__modal footer {
  justify-content: flex-end;
  gap: 6px;
  flex-wrap: wrap;
}
.bm-records__detail-pagination {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  max-width: 100%;
  padding: 0;
}
.bm-records__detail-pagination ::v-deep .el-pagination__jump {
  margin-left: 0;
}
.bm-records__mask {
  position: fixed;
  z-index: 3000;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(0, 0, 0, 0.4);
}
.bm-records__modal {
  display: flex;
  flex-direction: column;
  width: min(1000px, 100%);
  max-height: 85vh;
  overflow: hidden;
}
.bm-records__modal-body {
  min-height: 0;
  overflow: auto;
}
.bm-records__modal > header {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 18px;
  border-bottom: 1px solid #e0e0ec;
}
.bm-records__modal nav {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 10px 18px;
}
.bm-records__modal nav button {
  flex-shrink: 0;
  white-space: nowrap;
}
.bm-records__modal table {
  width: calc(100% - 36px);
  margin: 0 18px;
  min-width: 700px;
}
.bm-records__error-column {
  width: 180px;
  max-width: 180px;
}
.bm-records__error-text {
  display: block;
  width: 180px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.empty {
  padding: 28px !important;
  text-align: center;
  color: #999;
}
.wx-note { margin: 12px 18px; color: #999; font-size: 12px; line-height: 20px; }
.wx-note.danger { color: #c8443c; }
.bm-records__modal header strong { font-size: 14px; }
</style>
